import { Injectable } from '@angular/core';

export interface LoggedUserInfo {
	name: string;
	id: number;
	idV3: string;
	branchId: string;
	branchCode: number;
	branchName: string;
	email?: string;
}

@Injectable({
	providedIn: 'root',
})
export class LoggedUserService {
	public setLoggedUserInfo(userInfo: LoggedUserInfo): void {
		const loggedUserInfo = {
			id: userInfo.id,
			idV3: userInfo.idV3,
			branchId: userInfo.branchId,
			branchCode: userInfo.branchCode,
			branchName: userInfo.branchName,
			name: userInfo.name,
			email: userInfo.email,
		};

		const key = 'logged-user-info';
		const data = JSON.stringify(loggedUserInfo);

		localStorage.setItem(key, data);
		sessionStorage.setItem(key, data);
	}

	public getLoggedUserInfoFromLocalStorage(): LoggedUserInfo | null {
		const userInfo = localStorage.getItem('logged-user-info');
		return userInfo ? (JSON.parse(userInfo) as LoggedUserInfo) : null;
	}

	public clearLoggedUserInfo(): void {
		localStorage.removeItem('logged-user-info');
	}
}
